
<template>
  <el-date-picker
    v-bind="$attrs"
    v-on="$listeners"
   
  >
   <!-- :picker-options="pickerOptions" -->
    <template v-for="(_, slot) in $slots" #[slot]="scope">
      <slot :name="slot" v-bind="scope" />
    </template>
  </el-date-picker>
</template>

<script>
export default {
  name: 'AppDatePicker',
  inheritAttrs: false,
  data() {
    return {
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7 // 禁用今天之前的时间
        }
      }
    }
  }
}
</script>